import React, { useState } from 'react';
import {
  Box,
  Typography,
  Paper,
  Grid,
  Card,
  CardContent,
  CardActions,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  TextField,
  Divider,
  Snackbar,
  Alert,
  Link,
} from '@mui/material';
import {
  PlayCircleOutline as VideoIcon,
  WhatsApp as WhatsAppIcon,
  Article as ArticleIcon,
  Group as GroupIcon,
} from '@mui/icons-material';

const SuportePage: React.FC = () => {
  const [whatsappNumber, setWhatsappNumber] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState<'success' | 'error'>('success');

  const tutoriais = [
    {
      titulo: 'Como cadastrar produtos',
      tipo: 'video',
      link: 'https://youtube.com/tutorial-produtos',
      icon: <VideoIcon color="primary" />
    },
    {
      titulo: 'Gerenciando suas redes sociais',
      tipo: 'artigo',
      link: '/docs/redes-sociais.pdf',
      icon: <ArticleIcon color="primary" />
    },
    {
      titulo: 'Automatizando mensagens',
      tipo: 'video',
      link: 'https://youtube.com/tutorial-mensagens',
      icon: <VideoIcon color="primary" />
    },
  ];

  const handleJoinWhatsApp = () => {
    if (!whatsappNumber) {
      setSnackbarMessage('Por favor, insira seu número de WhatsApp');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
      return;
    }

    // Aqui você pode adicionar a lógica para adicionar o número ao grupo
    // Por enquanto, apenas mostraremos uma mensagem de sucesso
    setSnackbarMessage('Solicitação enviada! Em breve você receberá o link do grupo.');
    setSnackbarSeverity('success');
    setSnackbarOpen(true);
    setWhatsappNumber('');
  };

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom sx={{ mb: 4 }}>
        Central de Suporte
      </Typography>

      <Grid container spacing={4}>
        {/* Seção de Tutoriais */}
        <Grid item xs={12} md={6}>
          <Paper elevation={3} sx={{ p: 3 }}>
            <Typography variant="h5" gutterBottom sx={{ color: 'primary.main', fontWeight: 'bold' }}>
              Tutoriais
            </Typography>
            <Typography variant="body1" sx={{ mb: 3, color: 'text.secondary' }}>
              Aprenda a usar todas as funcionalidades do Vendedor Virtual
            </Typography>
            <List>
              {tutoriais.map((tutorial, index) => (
                <ListItem
                  key={index}
                  component={Link}
                  href={tutorial.link}
                  target="_blank"
                  sx={{
                    mb: 1,
                    bgcolor: 'background.paper',
                    borderRadius: 1,
                    '&:hover': {
                      bgcolor: 'action.hover',
                    },
                  }}
                >
                  <ListItemIcon>
                    {tutorial.icon}
                  </ListItemIcon>
                  <ListItemText 
                    primary={tutorial.titulo}
                    secondary={tutorial.tipo === 'video' ? 'Vídeo Tutorial' : 'Artigo'}
                  />
                </ListItem>
              ))}
            </List>
          </Paper>
        </Grid>

        {/* Seção de Comunidade WhatsApp */}
        <Grid item xs={12} md={6}>
          <Paper elevation={3} sx={{ p: 3 }}>
            <Typography variant="h5" gutterBottom sx={{ color: '#25D366', fontWeight: 'bold' }}>
              Comunidade WhatsApp
            </Typography>
            <Typography variant="body1" sx={{ mb: 3, color: 'text.secondary' }}>
              Participe do nosso grupo exclusivo e interaja com outros usuários
            </Typography>
            <Card sx={{ bgcolor: '#f0f8f1' }}>
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <GroupIcon sx={{ color: '#25D366', mr: 1 }} />
                  <Typography variant="h6">
                    Grupo de Usuários
                  </Typography>
                </Box>
                <Typography variant="body2" sx={{ mb: 2 }}>
                  Compartilhe experiências, tire dúvidas e receba dicas exclusivas sobre vendas e marketing digital.
                </Typography>
                <TextField
                  fullWidth
                  label="Seu número de WhatsApp"
                  variant="outlined"
                  placeholder="(11) 98765-4321"
                  value={whatsappNumber}
                  onChange={(e) => setWhatsappNumber(e.target.value)}
                  sx={{ mb: 2 }}
                />
              </CardContent>
              <CardActions>
                <Button
                  fullWidth
                  variant="contained"
                  startIcon={<WhatsAppIcon />}
                  onClick={handleJoinWhatsApp}
                  sx={{
                    bgcolor: '#25D366',
                    '&:hover': {
                      bgcolor: '#128C7E',
                    },
                  }}
                >
                  Participar do Grupo
                </Button>
              </CardActions>
            </Card>
          </Paper>
        </Grid>
      </Grid>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default SuportePage; 